export default "__VITE_ASSET__CConlDyr__"